
export class Claims {
    
    public static RightShipUser: string = 'RightShipUser';
    public static CanOverridePriceInAppPurchase: string = 'CanOverridePriceInAppPurchase';
    public static ShowDocumentRequirementInHome: string = "ShowDocumentRequirementInHome";
}